module.exports = __webpack_public_path__ + "static/img/acamy.dd002f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_logo/acamy.png
// module id = I8zO
// module chunks = 38